<template>
  <header class="Header">
    <div class="Header__inner">
      <a v-if="isHome" class="Header_menu__logo" @click="reloadPage()">
        <img
          alt="Logo"
          class="Header_menu__logo_img _dsp-none--sp"
          src="assets/img/melon_logo_blue.png"
        ><img
          alt="Logo"
          class="Header_menu__logo_img _dsp-none--pc"
          src="assets/img/melon_logo_white.png"
        >
      </a>
      <a v-else class="Header_menu__logo" @click="reloadPage()">
        <img
          alt="Logo"
          class="Header_menu__logo_img"
          src="assets/img/melon_logo_blue.png"
        >
      </a>
      <div class="Heade__main ft_en">
        <div class="Header__menu_area" :aria-hidden="menuHeaderOpen ? 'true' : 'false'">
          <RouterLink
            v-for="(menu,key) of headerMenus"
            :key="key"
            :class="['Header__menu_link', menu.menuClass, 'ft_en']"
            :active-class="'Header__menu_link--active'"
            :exact-path="true"
            :to="menu.path"
          >
            {{ menu.name }}
          </RouterLink>
        </div>
        <div
          :class="`Header__menu Header__menu_link Header__menu_link_other Header__toggle
              ${isHome ? '' : 'Header__menu_link_other_sp--white'}
              ${notifications.length ? 'Header__menu_link_other--alert' : ''}`"
          :aria-label="menuToggleLabel"
          role="button"
          tabindex="0"
          @click="toggleMenuHeader()"
        >
          <div class="Header__menu_link_other_tx _dsp-none--sp ft_en">
            Other
          </div>
        </div>
      </div>
    </div>
    <other-menu-header :notifications="notifications" :other-menus="otherMenus" />
  </header>
</template>

<script>

import { mapGetters, mapState } from 'vuex'
import OtherMenuHeader from '@/views/layouts/Header/OtherMenuHeader'
import { redirect } from '@/helpers'

export default {
  components: { OtherMenuHeader },
  data() {
    return {
      otherMenus: [],
      hasUnReadNotification: true
    }
  },
  computed: {
    ...mapState({
      isHome: state => state.layout.isHome,
      menuHeaderOpen: state => state.layout.menuHeaderOpen,
      emailHash: state => state.user.emailHash,
      userCategory: state => state.user.userInfo.ccategory
    }),
    ...mapGetters({
      notifications: 'notification/listNotifications'
    }),
    headerMenus() {
      return [
        {
          path: '/',
          name: 'Home',
          menuClass: 'Header__menu_link_home',
          is_internal: true
        },
        {
          path: '/melon-tv',
          name: 'MELON TV',
          menuClass: 'Header__menu_link_tv',
          is_internal: true
        },
        {
          path: '/log',
          name: 'Log',
          menuClass: 'Header__menu_link_log',
          is_internal: true
        },
        {
          path: '/mindful-survey' + ([5, 6].includes(this.userCategory) ? '/company' : '') + '?uuid=' + this.emailHash,
          name: 'CHECKER',
          menuClass: 'Header__menu_link_checker',
          is_internal: true
        }
      ]
    },
    menuToggleLabel() {
      return this.menuHeaderOpen ? 'メニューを閉じる' : 'メニュー'
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.otherMenus = this.handleOtherMenus(this.getOtherMenus())
    },
    toggleMenuHeader() {
      this.$store.dispatch('layout/toggleMenuHeader')
    },
    getOtherMenus() {
      return [
        {
          title: 'MELONの使い方',
          path: '/tutorial',
          is_internal: true,
          menuOtherClass: '',
          target: '_self'
        },
        {
          title: 'クラス参加',
          path: '/zoom-setup',
          is_internal: true,
          menuOtherClass: '',
          target: '_self'
        },
        {
          title: 'MELON TV',
          path: '/melon-tv',
          is_internal: true,
          menuOtherClass: 'ft_en',
          target: '_self'
        },
        {
          title: 'ログページ',
          path: '/log',
          is_internal: true,
          menuOtherClass: '',
          target: '_self'
        },
        {
          title: 'お気に入り一覧',
          path: '/class',
          is_internal: true,
          menuOtherClass: '',
          target: '_self'
        },
        {
          title: 'お知らせ一覧',
          path: '/information',
          is_internal: true,
          menuOtherClass: '',
          target: '_self'
        },
        {
          title: 'MELON 公式サイト',
          path: 'https://www.the-melon.com/',
          is_internal: false,
          menuOtherClass: '',
          target: '_self'
        },
        {
          title: '友達に紹介する',
          path: '/introduction',
          is_internal: true,
          menuOtherClass: '',
          target: '_self'
        },
        {
          title: 'MELON SHOP',
          path: 'https://themelon.thebase.in/',
          is_internal: false,
          menuOtherClass: 'ft_en',
          target: '_self'
        },
        {
          title: '設定',
          path: '/change',
          is_internal: true,
          menuOtherClass: '',
          target: '_self'
        },
        {
          title: 'よくある質問',
          path: 'https://docs.google.com/presentation/d/e/2PACX-1vS1WPxwXDwoxcvN-FjdAbGfNmq5RFwM0HEDwJrKuhYWjACCYMAqATPShB5_EuYAqpRIoFUlZVbwKsJE/pub?start=false&loop=false&delayms=3000',
          is_internal: false,
          menuOtherClass: '',
          target: '_blank'
        },
        {
          title: 'お問い合わせ',
          path: 'https://www.the-melon.com/contacts/',
          is_internal: false,
          menuOtherClass: '',
          target: '_blank'
        },
        {
          title: 'ログアウト',
          path: '/users/logout',
          is_internal: true,
          target: '_self'
        }
      ]
    },
    handleOtherMenus(listMenus) {
      const result = []
      while (listMenus.length) {
        result.push(listMenus.splice(0, 8))
      }
      return result
    },
    reloadPage() {
      if (this.$route.path === '/') {
        window.location.reload()
      } else {
        redirect('/')
      }
    }
  }
}

</script>
